// extracted by mini-css-extract-plugin
export var closeButton = "_ot-2";
export var closeButtonIcon = "_ot-3";
export var lightboxContent = "_ot-1";
export var lightboxOverlay = "_ot-0";